import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

const ICONS = {
  box: 'M4 8h16l-1.5 11.2A2 2 0 0 1 16.5 21h-9a2 2 0 0 1-2-1.8L4 8Zm4-3h8l1 3H7l1-3Z',
  calendar: 'M4 6h16v14H4V6Zm0 4h16M9 3v4M15 3v4',
  shop: 'M4 9h16l-1 11H5L4 9Zm4 0V7a4 4 0 0 1 8 0v2',
  person: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8a7 7 0 0 1 14 0',
};

const TABS = [
  { to: '/app', label: 'Today', icon: ICONS.box, end: true },
  { to: '/products', label: 'Shop', icon: ICONS.shop },
  { to: '/app/orders', label: 'Orders', icon: ICONS.calendar },
  { to: '/app/profile', label: 'Account', icon: ICONS.person },
];

/**
 * Mobile tab bar for signed-in members. Hidden from `sm` up, where the header
 * nav already covers the same destinations.
 */
export default function BottomNav() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <nav
      aria-label="Sections"
      // Elevated with a soft *upward* shadow so the bar reads as floating above
      // the page content; hairline top border keeps a crisp edge over blur.
      className="pad-safe-bottom fixed inset-x-0 bottom-0 z-40 border-t border-oat-dark/70 bg-surface/90 shadow-[0_-6px_20px_-8px_rgba(14,59,34,0.14)] backdrop-blur-md sm:hidden"
    >
      <ul className="flex items-stretch justify-around px-1 pt-1">
        {TABS.map((tab) => (
          <li key={tab.to} className="flex-1">
            <NavLink
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                [
                  'flex min-h-touch flex-col items-center justify-center gap-1 rounded-2xl py-1.5 text-2xs font-semibold transition-colors duration-150',
                  isActive ? 'text-heading' : 'text-ink-faint active:text-brand',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  {/* Active tab highlights with a leaf-tint pill behind the icon. */}
                  <span
                    className={[
                      'flex items-center justify-center rounded-full px-4 py-0.5 transition-colors duration-150',
                      isActive ? 'bg-leaf-100' : 'bg-transparent',
                    ].join(' ')}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      className="h-6 w-6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={isActive ? 2.2 : 1.7}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d={tab.icon} />
                    </svg>
                  </span>
                  {tab.label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
